import LzTag from './tag.vue';

LzTag.install = function(Vue) {
  Vue.component(LzTag.name, LzTag);
};

export default LzTag;